import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/peter-fry")({
  head: () => buildRouteHead("/peter-fry", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/en/about-qbd/board-of-advisors", replace: true });
  },
});
